module.exports = __webpack_public_path__ + "img/hover-question-black.9c0f1b13.svg";